export default "__VITE_ASSET__BrSf$40m__"